import { readData } from "@/__main__/get-data.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import { devError } from "@/util/dev.mjs";
import lazyFn from "@/util/lazy-fn.mjs";

// Val
const fetchAgentSelect = lazyFn(
  () => import("@/game-val/valorant-fetch-overlay-agent-select.mjs"),
);
const fetchLoadingScreen = lazyFn(
  () => import("@/game-val/valorant-fetch-overlay-loading-screen.mjs"),
);
const fetchBenchmarking = lazyFn(
  () => import("@/game-val/valorant-fetch-overlay-benchmarking.mjs"),
);

const CRITICAL_STATE_PATHS = [["settings"], ["user"]];

async function initializeUserData() {
  try {
    await Promise.all(
      CRITICAL_STATE_PATHS.map((path) => {
        return readData(path, { forceReadFromDB: true });
      }),
    );
  } catch (e) {
    devError("FAILED TO INITIALIZE USER DATA", e);
  }
}

const routes: BaseRoute[] = [
  {
    path: "/valorant/overlay",
    component: "game-val/Overlay.jsx",
  },
  {
    path: "/valorant/overlay/agent-select",
    component: "game-val/AgentSelect.jsx",
    fetchData: async function (...rest) {
      await initializeUserData();
      return fetchAgentSelect(...rest);
    },
  },
  {
    path: "/valorant/overlay/loading-screen",
    component: "game-val/LoadingScreen.jsx",
    fetchData: async function (...rest) {
      await initializeUserData();
      return fetchLoadingScreen(...rest);
    },
  },
  {
    path: "/valorant/overlay/benchmark",
    component: "game-val/BenchmarkOverlay.jsx",
    fetchData: async function (...rest) {
      await initializeUserData();
      return fetchBenchmarking(...rest);
    },
  },
];

export default routes;
